exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".copyConfigContainer {\n  display: grid !important;\n  max-width: none;\n  border: solid 2px red;\n  width: 100%;\n  padding: 1em;\n  margin: 2em;\n}\n\n.configBoxs {\n  margin: 0.5em;\n  max-width: 48% !important;\n}\n\n.row_body {\n  width: 100%;\n}\n\n.configRow {\n  padding: 0.2em;\n  background: #e9e9e9;\n  margin: 0.5em;\n  display: flex;\n  width: 100%;\n}\n\n.buttonRow {\n  display: grid !important;\n  justify-content: end;\n}", ""]);

// exports
